const MAX_TITLE_LENGTH = 68; // ScheduledSessionSchema name max
const SURFACE_MAP = {
    screen: 'monitor',
    window: 'window',
    tab: 'browser',
};
export function parseShareParams(raw) {
    const surface = raw.surface === 'window' || raw.surface === 'tab'
        ? raw.surface
        : 'screen';
    const name = raw.name?.trim() ? raw.name.trim() : undefined;
    const title = (raw.title?.trim() ? raw.title.trim() : 'Screen share').slice(0, MAX_TITLE_LENGTH);
    return {
        surface,
        displaySurface: SURFACE_MAP[surface],
        includeAudio: surface === 'tab',
        name,
        title,
    };
}
/**
 * Maps getDisplayMedia failures to actionable messages. Rendered in
 * [data-automation-id="share-error"], which agents read — the message must
 * tell them (or the human they relay it to) exactly what to fix.
 */
export function getCaptureErrorMessage(e) {
    if (e instanceof DOMException) {
        if (e.name === 'NotAllowedError') {
            return 'Screen sharing was not allowed. Click to try again.';
        }
        if (e.name === 'NotReadableError') {
            return ('The browser was not allowed to read the screen. On macOS, ' +
                'grant Screen Recording permission to this browser in System ' +
                'Settings → Privacy & Security → Screen & System Audio ' +
                'Recording, restart the browser, and try again.');
        }
    }
    return 'Could not start screen capture. Click to try again.';
}
